module.exports = __webpack_public_path__ + "bfad79a7c5e48d96673bd147e0bbfc4a.jpg";